<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Careers
                                    <span>WORK AT SMAKITNEL.</span>
                                </h1>
                                
                                <p class="lead  text-white">Interested in becoming part of the fun, vibrant team? <br>
Find out more about our openings here.
                                </p>

                                <p class="lead  text-white">
                                    Browse our open positions and when you see one that you can excel in, drop us an email at hr@smakintel.com,

                                    sharing with us why SMAKINTEL can go to the next level with you onboard.
                                    
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-lg">
              <div class="container container-lg">
                    <div class="row">
                        <div class="col-md-4 mb-4 mb-md-0">

                             <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Web Developer Internship</h6>

                                    <p class="description mt-3">Web Developer interns will be involved in software development for web application. <br><br> The software development takes in the direction of automation of business processes.  </p>
                                
                                   <table class='table'>
                                       <tr>
                                            <td colspan='2'><strong>Responsibilities</strong></td>
                                        </tr>
                                         <tr>
                                            <td colspan='2'>Front-end development with Bootstrap.</td>
                                        </tr>
                                        
                                        <tr>
                                            <td colspan='2'>Write well-designed, testable code.</td>
                                        </tr>
                                        <tr>
                                        <td colspan='2'>Troubleshoot, debug and upgrade existing systems.</td>
                                        </tr>
                                        
                                       
                                        <tr>
                                            <td colspan='2'><strong>Requirements</strong></td>
                                        </tr>

                                         <tr>
                                            <td colspan='2'>(Preferred) Basic HTML, Bootstrap, Javascript</td>
                                        </tr>

                                        <tr>
                                            <td colspan='2'><strong>Qualifications</strong></td>
                                        </tr>

                                         <tr>
                                            <td colspan='2'>This position is open to students who completed atleast foundation Diploma in Information Technology..</td>
                                        </tr>


                                    </table>

                                    <base-button tag="a" href="/contact-us" type="primary" class="mt-4">
                                        Apply
                                    </base-button>
                                </card>

                </div>

                  <div class="col-md-4 mb-4 mb-md-0">
                   
                                      <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Cloud Support Engineer</h6>

                                    <p class="description mt-3">The Cloud Support Engineer is responsible to ensure service availability, performance and a good security posture of the systems running in the Cloud environment, in provisioning core infrastructure services of large system. The operational tasks required need to be fulfilled in a timely, co-operative and professional manner with the other infrastructure engineering teams.</p>
                                
                                   <table class='table'>
                                       <tr>
                                            <td colspan='2'><strong>Responsibilities</strong></td>
                                        </tr>
                                        <tr>
                                            <td colspan='2'> Responsible for day-to-day customer care and administration of cloud services</td>
                                        </tr>
                                        <tr>
                                        <td colspan='2'>Respond to escalated customer service issues using email, phone, and web conference technology.</td>
                                        </tr>

                                        <tr>
                                        <td colspan='2'>Work within a global support team covering 24x7x365 cloud operations</td>
                                        </tr>

                                         <tr>
                                        <td colspan='2'>Responsible for general health and maintenance of cloud service offerings</td>
                                        </tr>

                                       
                                        <tr>
                                            <td colspan='2'><strong>Requirements</strong></td>
                                        </tr>

                                         <tr>
                                            <td colspan='2'>Willingness to learn and adapt to the entire technology stack.</td>
                                        </tr>

                                         <tr>
                                            <td colspan='2'>Solid research skills with an emphasis on finding and using information quickly</td>
                                        </tr>

                                        <tr>
                                            <td colspan='2'>Certification as an AWS or equivalent Cloud Computing Engineer is an added advantage</td>
                                        </tr>

                                        <tr>
                                            <td colspan='2'>Self-motivated, customer-oriented and a strong team player</td>
                                        </tr>

                                        



                                    </table>

                                    <base-button tag="a" href="/contact-us" type="primary" class="mt-4">
                                        Apply
                                    </base-button>
                                </card>                            
                    
                </div>

                <div class="col-md-4 mb-4 mb-md-0">
                   
                    <card class="border-0" hover shadow body-classes="py-5">
                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                    </icon>
                    <h6 class="text-primary text-uppercase">Junior Full Stack Developer</h6>

                    <p class="description mt-3">We are looking for a technically gifted and ambitious individuals to join us as Junior Full Stack Developer. <br><br> Ideally you are someone who can hustle and is willing to learn. You'll be treated just like any of your senior developers, so get ready for long hours, getting your hands dirty and lots of hard work. </p>
                
                    <table class='table'>
                        <tr>
                            <td colspan='2'><strong>Responsibilities</strong></td>
                        </tr>
        
                        <tr>
                            <td colspan='2'>Decent PHP, Javascript,jQuery, HTML, CSS,Vue</td>
                        </tr>

                         <tr>
                            <td colspan='2'>MySQL,GitHub</td>
                        </tr>


                        <tr>
                            <td colspan='2'>Write well-designed, testable code.</td>
                        </tr>

                        <tr>
                        <td colspan='2'>Troubleshoot, debug and upgrade existing systems.</td>
                        </tr>
                        
                        <tr>
                            <td colspan='2'><strong>Requirements</strong></td>
                        </tr>

                        <tr>
                            <td colspan='2'>A degree is not needed, as long as you can show what you’ve worked on or done something using technologies mentioned above.</td>
                        </tr>

                        <tr>
                            <td colspan='2'>Have at least 1 year of experience in one or more of these technologies</td>
                        </tr>


                    </table>

                    <base-button tag="a" href="/contact-us" type="primary" class="mt-4">
                        Apply
                    </base-button>
                </card>
            
                </div>

            </div> <!-- end row -->
            <div class='row'>
                 <div class="col-md-4 mb-4 mb-md-0">
                   
                    <card class="border-0" hover shadow body-classes="py-5">
                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                    </icon>
                    <h6 class="text-primary text-uppercase">QA Engineer (PHP)</h6>

                    <p class="description mt-3">This role will interface with development, product and brand teams to make sure we are delivering high quality applications and tools. 
                    You will be supporting the delivery of a wide variety of projects including web-based applications
                    </p>
                
                    <table class='table'>
                        <tr>
                            <td colspan='2'><strong>Responsibilities</strong></td>
                        </tr>
                        <tr>
                            <td colspan='2'>Work with engineering team and business owners to develop acceptance criteria,test strategy, and test cases</td>
                        </tr>
                        <tr>
                        <td colspan='2'>Responsible for test case execution,planning,maintenance,and reporting</td>
                        </tr>

                         <tr>
                        <td colspan='2'>Takeownership on root cause analysis on application and environment issues</td>
                        </tr>

                         <tr>
                        <td colspan='2'>Validate data flow throughout application workflow(end to end)</td>
                        </tr>

                         <tr>
                        <td colspan='2'>Partner with Development and Product teams to deliver quality products on time</td>
                        </tr>


                        <tr>
                            <td colspan='2'><strong>Requirements</strong></td>
                        </tr>

                         <tr>
                            <td colspan='2'>A degree is not needed, as long as you can show what you’ve worked on or done something using technologies mentioned above.</td>
                        </tr>



                        <tr>
                            <td colspan='2'>Investigate and debug issues when they occur</td>
                        </tr>
                        <tr>
                            <td colspan='2'>Ability to write and communicate technical test plans and test cases</td>
                        </tr>

                        <tr>
                            <td colspan='2'>Ability to troubleshoot and debug issues to the root cause</td>
                        </tr>

                        <tr>
                            <td colspan='2'>Experience in and passionate about QA methodologies</td>
                        </tr>

                        <tr>
                            <td colspan='2'>Ability to write and execute SQL statements</td>
                        </tr>

                        <tr>
                            <td colspan='2'>Approaches challenges with optimism and a positive attitude</td>
                        </tr>

                    </table>

                    <base-button tag="a" href="/contact-us" type="primary" class="mt-4">
                        Apply
                    </base-button>
                </card>
            
                </div>

            </div>

        </div>
        </section>
       

         <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Looking for something else?</h3>
                              
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="/contact-us"
                                             type="white" block size="lg">
                                    Contact Us
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>

       
        
      
       
       

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>
